import React from "react";
import ScrollReveal from "@/components/ScrollReveal";
import BrassRule from "@/components/BrassRule";
import { useLang } from "@/lib/i18n";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section data-testid="manifesto-section" className="relative bg-ivory">
      <div className="mx-auto max-w-3xl px-6 md:px-10 py-32 md:py-40 text-center">
        <ScrollReveal>
          <p className="eyebrow text-charcoal/80">{t.home.manifesto_eyebrow}</p>
        </ScrollReveal>
        <ScrollReveal delay={120}>
          <h2
            className="font-display text-charcoal mt-8 leading-[1.08] text-balance"
            style={{ fontSize: "clamp(2.25rem, 4.5vw, 3.5rem)" }}
          >
            {t.home.manifesto_headline_main}
            <br />
            <span className="italic-quote font-normal" style={{ fontWeight: 400 }}>
              {t.home.manifesto_headline_italic}
            </span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={220}>
          <div className="mt-12 space-y-7 text-charcoal/85 text-[17px] md:text-[18px] leading-[1.85] text-pretty">
            <p>{t.home.manifesto_p1}</p>
            <p>{t.home.manifesto_p2}</p>
            <p>{t.home.manifesto_p3}</p>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={320}>
          <BrassRule className="mt-14" width={60} />
        </ScrollReveal>
      </div>
    </section>
  );
}
